import { render, staticRenderFns } from "./professionalTown.vue?vue&type=template&id=01b586ba&"
import script from "./professionalTown.vue?vue&type=script&lang=js&"
export * from "./professionalTown.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports